import type { ReactiveControllerHost } from 'lit';
import { CustomError } from '../../../../_ui-core_/base/package/patterns/package/CError';
import App from '../../../../app';
import BaseController, { type EventAction, type IGameController } from '../base-controller';

type GgEvent = {
  event?: string | object;
};

type GgErrorEvent = {
  name: string;
  message: string;
  display_message: string;
  code: string;
};

export default class GamesglobalGameController extends BaseController implements IGameController {
  constructor(host: ReactiveControllerHost) {
    super(host, 'gg');
  }

  public async getLaunchUrl(forReal: boolean, gameId: string): Promise<string> {
    try {
      const info = await App.instance.casino.getGameLaunchInfo(this.provider, gameId, forReal);

      if (!info.launchConfig.launchUrl) {
        return Promise.reject(new CustomError('Launch URL is missing.', { code: 404 }));
      }

      return info.launchConfig.launchUrl;
    } catch (error: any) {
      return Promise.reject(
        new CustomError(`Failed to get game launch info: ${error.message}`, {
          code: error.code || 500,
          type: error.type,
        }),
      );
    }
  }

  public getLaunchUrlIOs(forReal: boolean, gameId: string, gameBaseUrl: string): Promise<string> {
    window.$app.logger.warn('TODO - NATIVE GAME LAUNCH NOT IMPLEMENTED!', gameBaseUrl);
    return this.getLaunchUrl(forReal, gameId); // TODO
  }

  public handleMessageEvent(data: GgEvent): EventAction | null {
    window.$app.logger.log('message', data);

    // https://integrationdocs.gamesglobal.com/docs/extended-game-to-host
    const event = data.event;
    if (typeof event === 'string') {
      switch (event) {
        case 'gameBusy':
          return this.markActivity();
        case 'WagerStarted':
          return this.markActivity();
        case 'launchlobby':
          return this.closeGame();
      }
    }
    if (typeof event === 'object') {
      const errorEvent = event as GgErrorEvent;
      if (errorEvent.code && errorEvent.display_message) {
        // TODO better error handling?
        // TODO: Update: tried to simulate some errors but there was no messaging going on
        return { action: 'error', error: errorEvent.display_message };
      }
    }

    return null;
  }

  public handleAdditionalEventListeners(_iframeUrl: string, _iframeEl: HTMLIFrameElement) {
    return;
  }
}
